import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Check, CreditCard, HardHat, LayoutGrid, LogOut, Moon, Sun, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const AppSidebarLayout: React.FC = () => {
  const navigate = useNavigate();
  const { username, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  const displayName = (username && username.trim()) || 'User 1';

  const handleLogout = async () => {
    await logout();
    navigate('/', { replace: true });
  };

  return (
    <div className="app-container">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <img
              src={theme === 'dark' ? '/bidflowlogo-removebg-preview.png' : '/output-onlinepngtools.png'}
              alt="Bidflow"
              className="sidebar-brand-logo"
            />
            <span className="sidebar-title">Bidflow</span>
          </div>
          <div className="sidebar-header-actions">
            <button
              type="button"
              className={`sidebar-theme-slider ${theme === 'dark' ? 'dark' : 'light'}`}
              onClick={toggleTheme}
              title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
              aria-label={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
            >
              <span className="sidebar-theme-slider-handle">
                {theme === 'dark' ? <Sun size={10} /> : <Moon size={10} />}
              </span>
            </button>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">
            <div className="nav-group">
              <NavLink to="/takeoffs" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
                <LayoutGrid className="nav-icon" />
                <span>Takeoffs</span>
              </NavLink>
              <div className="nav-subitems">
                <NavLink to="/takeoffs/estimating" end className={({ isActive }) => `nav-subitem${isActive ? ' active' : ''}`}>
                  <HardHat size={13} className="nav-subicon" aria-hidden="true" />
                  <span>Estimating</span>
                </NavLink>
                <NavLink to="/takeoffs/completed" end className={({ isActive }) => `nav-subitem${isActive ? ' active' : ''}`}>
                  <Check size={13} className="nav-subicon" aria-hidden="true" />
                  <span>Completed</span>
                </NavLink>
              </div>
            </div>
            <NavLink to="/settings/billing" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
              <CreditCard className="nav-icon" />
              <span>Billing & Usage</span>
            </NavLink>
          </div>
        </nav>

        <div className="sidebar-footer">
          <span className="sidebar-user-inline" title={displayName}>
            <User size={16} className="sidebar-user-icon" />
            <span className="sidebar-user-name">{displayName}</span>
          </span>
          <button type="button" className="logout-button" onClick={() => void handleLogout()} title="Log out">
            <LogOut size={16} />
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AppSidebarLayout;
